import type { ComponentType } from 'react'
import {
  IconeModuloBleve,
  IconeModuloCaminhao,
  IconeModuloPluma,
  IconeModuloTabletop,
  IconeModuloTransbordo,
  type PropsIcone,
} from '../icones'

/**
 * Os módulos do laboratório, numa tabela só. Acrescentar um módulo é
 * acrescentar uma linha aqui e um caso em `App.tsx`.
 */

export type IdModulo = 'caminhao' | 'bleve' | 'pluma' | 'transbordo' | 'tabletop'

export interface Modulo {
  id: IdModulo
  /** Nome curto, usado na navegação. */
  rotulo: string
  /** Nome completo, usado em títulos e rótulos acessíveis. */
  titulo: string
  Icone: ComponentType<PropsIcone>
}

export const MODULOS: readonly Modulo[] = [
  {
    id: 'caminhao',
    rotulo: 'Identificação',
    titulo: 'Identificação do produto',
    Icone: IconeModuloCaminhao,
  },
  {
    id: 'bleve',
    rotulo: 'BLEVE e zonas',
    titulo: 'BLEVE e zonas de trabalho',
    Icone: IconeModuloBleve,
  },
  {
    id: 'pluma',
    rotulo: 'Pluma tóxica',
    titulo: 'Vazamento tóxico e pluma',
    Icone: IconeModuloPluma,
  },
  {
    id: 'transbordo',
    rotulo: 'Transbordo',
    titulo: 'Transbordo de carga',
    Icone: IconeModuloTransbordo,
  },
  {
    id: 'tabletop',
    rotulo: 'Table top',
    titulo: 'Table top HAZMAT',
    Icone: IconeModuloTabletop,
  },
]

export function moduloPorId(id: IdModulo): Modulo {
  const achado = MODULOS.find((modulo) => modulo.id === id)
  if (!achado) throw new Error(`Módulo desconhecido: ${id}`)
  return achado
}
